import React, { useState, useEffect } from "react";
import {Container,Typography,Button,Stack,} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import axios from "axios";
import Swal from "sweetalert2";
import { BASE_URL } from "../../App";


const RetailReportExcelDownload = () => {
	
const login_id = localStorage.getItem("LOGIN_ID");
const BRANCH_CODE = localStorage.getItem("BRANCH_CODE");
	
   const fallbackSchemes = [
     { scheme_id: "dummy1", scheme_name: "Please wait..." },
    { scheme_id: "dummy2", scheme_name: "Fetching Schemes..." },
   ];

  const [schemes, setSchemes] = useState(fallbackSchemes);
  const [downloadingId, setDownloadingId] = useState(null);
  const [logindata, setlogindata] = useState([]);
  const [branchdata, setbranchdata] = useState([]);

  useEffect(() => {
    const fetchSchemes = async () => {
      try {
        const res = await axios.get(BASE_URL + "/getSchemesforretailerdownload");
        const schemes = res.data?.data || [];
  
        setSchemes(schemes);
  
        if (schemes.length === 0) {
          Swal.fire("Info", "No schemes available", "info");
        }
      } catch (error) {
        console.error("Error fetching schemes:", error);
        setSchemes([]);
        Swal.fire("Error", "Failed to load schemes", "error");
      }
    };
  
    const getLoginAndBranchDecode = async () => {
      try {
        const loginRes = await axios.post(BASE_URL + "/getloginidDecode", { login_id :login_id });
        const loginData = loginRes.data.login_id;
        setlogindata([loginData]);
  
        const branchRes = await axios.post(BASE_URL + "/getBranchDecode", { BRANCH_CODE:BRANCH_CODE });
        const branchData = branchRes.data.BRANCH_CODE;
        setbranchdata([branchData]);

      } catch (error) {
        console.error("Error in login/branch encoding:", error);
        Swal.fire("Error", "Failed to encode login or branch", "error");
      }
    };
  
    getLoginAndBranchDecode();
    fetchSchemes();
  }, []);
  
  
 
  const handleDownload = async (schemeId, schemeName) => {
    if (schemeId.toString().startsWith("dummy")) return;
  
    try {
      setDownloadingId(schemeId);
    
      // Show Swal loading modal
      Swal.fire({
        title: "Downloading...",
        text: `Please wait while "${schemeName}" is being downloaded.`,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    
      const url = `https://mobile.cri.in/others/retailer_app/report/Exceltotalpts.php?schemeid=${schemeId}&employeebranch=${branchdata}&employeecode=${logindata}`;
      window.open(url, '_blank');
    
      Swal.close(); // Close Swal after opening the download
    } catch (error) {
      console.error("Download failed:", error);
      Swal.fire("Error", "Failed to open download", "error");
    } finally {
      setDownloadingId(null);
    }
  };    
      /*const res = await axios.get(
        `https://mobile.cri.in/others/retailer_app/report/Exceltotalpts.php?schemeid=${schemeId}&employeebranch=${branchdata}&employeecode=${logindata}`
      );
      const blob = new Blob([res.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${schemeName}_${schemeId}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
  
      Swal.close(); // Close Swal once download is triggered
    } catch (error) {
      console.error("Download failed:", error);
      Swal.fire("Error", "Failed to download file", "error");
    } finally {
      setDownloadingId(null);
    }*/
  
  

  return (
    <Container>
      {/* <Typography variant="h5" gutterBottom mt={3}>
        Download Retailer Scheme Excel Reports
      </Typography> */}

      {schemes.length > 0 ? (
        <Stack direction="row" flexWrap="wrap" gap={2} mt={3}>
          {schemes.map((scheme) => (
            <Button
              key={scheme.scheme_id}
              variant="outlined"
              color="info"
              onClick={() => handleDownload(scheme.scheme_id, scheme.scheme_name)}
              disabled={
                scheme.scheme_id.toString().startsWith("dummy") ||
                downloadingId === scheme.scheme_id
              }
            >
              {downloadingId === scheme.scheme_id
                ? "Downloading..."
                : `Download ${scheme.scheme_name}`}
            </Button>
          ))}
        </Stack>
      ) : (
        <Typography mt={2} color="textSecondary">
          No schemes available for download.
        </Typography>
      )}
    </Container>
  );
};

export default RetailReportExcelDownload;
